// extracted by mini-css-extract-plugin
export default {"brandButton":"BrandButton_brandButton__n7YaZ"};